import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { TRAINING_CATEGORIES } from "../../data/content";
import { Reveal } from "./Reveal";

export const ProfessionalTraining = () => {
  const [open, setOpen] = useState(0);
  const total = TRAINING_CATEGORIES.reduce((n, c) => n + c.courses.length, 0);

  return (
    <section className="section section--alt" id="training" aria-labelledby="training-heading">
      <div className="container">
        <div className="section-header" style={{ textAlign: "center" }}>
          <div className="section-label">Continuous Learning</div>
          <h2 className="section-heading" id="training-heading">
            Professional <em>Training &amp; Courses</em>
          </h2>
          <p className="section-sub" style={{ marginInline: "auto" }}>
            {total}+ certificate courses and professional trainings across {TRAINING_CATEGORIES.length} domains —
            from MERL and governance to AI, data protection, climate, and humanitarian safety.
          </p>
        </div>

        <div className="pt-accordion">
          {TRAINING_CATEGORIES.map((cat, i) => {
            const Icon = cat.icon;
            const isOpen = open === i;
            return (
              <Reveal className="pt-item" key={cat.title} delay={(i % 4) * 40}>
                <button
                  className={`pt-header ${isOpen ? "open" : ""}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  data-testid={`training-cat-${i}`}
                >
                  <span className="pt-icon"><Icon size={18} /></span>
                  <span className="pt-cat">{cat.title}</span>
                  <span className="pt-count">{cat.courses.length}</span>
                  <ChevronDown className="pt-chevron" size={18} aria-hidden="true" />
                </button>
                <div className={`pt-content ${isOpen ? "open" : ""}`}>
                  <div className="pt-content-inner">
                    <div className="pt-courses">
                      {cat.courses.map((c) => (
                        <div className="pt-course" key={c.name}>
                          <span className="pt-course-name">{c.name}</span>
                          <span className="pt-course-meta">{c.meta}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
